export default "__VITE_ASSET__D$0CKM9y__"